import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Link,
  Typography,
} from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  card: {
    height: "47vh",
    // borderColor: theme.palette.primary.light,
    borderWidth: 0,
    borderRadius: 20,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    transition: "all 0.5s ease",
    "&:hover": {
      // boxShadow: "0px 0px 20px rgba(0,0,0,0.4)",
      borderColor: theme.palette.primary.light,
    },
  },
  CardHeader: {
    backgroundColor: theme.palette.secondary.main,

    // margin: 0,
    // paddingBottom: 10,
  },
  CardHeaderRoot: {
    backgroundColor: theme.palette.secondary.main,
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    // padding: 10,
  },
  CardHeaderTitle: {
    fontWeight: 600,
    // color: theme.palette.primary.main,
  },
  link: {
    // marginTop: theme.spacing(1),
    // marginRight: theme.spacing(2),
  },
  CardContent: {
    height: "100%",
  },
  readmoreBtnContainer: {
    // backgroundColor: "red",

    display: "flex",
    justifyContent: "flex-end",
    padding: 15,
  },
  readmoreBtn: {
    borderRadius: 100,
  },
}));

const ContainerCard = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Card className={classes.card} variant="outlined">
        <CardHeader
          classes={{
            root: classes.CardHeaderRoot,
          }}
          title={
            <div className={classes.CardHeader}>
              <Typography className={classes.CardHeaderTitle} variant="h5">
                {props.title || "title"}
              </Typography>
            </div>
          }
        />
        <CardContent className={classes.CardContent}>
          {props?.children}
        </CardContent>
        <div className={classes.readmoreBtnContainer}>
          <Button
            color="primary"
            variant="outlined"
            className={classes.readmoreBtn}
          >
            {props?.linkTitle}
            {/* <Typography
              align="right"
              variant="body1"
              className={classes.link}
              paragraph
            >
              <Link href={props?.link}>{props?.linkTitle}</Link>
            </Typography> */}
          </Button>
        </div>
      </Card>
    </div>
  );
};
export default ContainerCard;
